import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import dictionariesReduces from './dictionaries/slice';
import statusesReduces from './statuses/slice';
import generalLedgerListReducer from '../hoc/general-ledger/store/slices/list';
import generalLedgerTransactionReducer from '../hoc/general-ledger/store/slices/transaction';
import transactionFeeReducer from '../hoc/general-ledger/store/slices/transaction-fee';
import internalListReducer from '../hoc/internal/store/slices/list';
import internalTransactionReducer from '../hoc/internal/store/slices/transaction';
import incomingListReducer from '../hoc/incoming/store/slices/list';
import incomingTransactionReducer from '../hoc/incoming/store/slices/transaction';
import outgoingListReducer from '../hoc/outgoing/store/slices/list';
import outgoingTransactionReducer from '../hoc/outgoing/store/slices/transaction';
import exportBanksReducer from '../hoc/export/store/slices/banks';
import exportAccountsReducer from '../hoc/export/store/slices/accounts';
import exportBatchesReducer from '../hoc/export/store/slices/batches';
import exportTransactionListReducer from '../hoc/export/store/slices/list';
import importTransactionListReducer from '../hoc/import/store/slices/list';
import nostroListReducer from '../hoc/nostro/store/slices/list';
import nostroTransactionReducer from '../hoc/nostro/store/slices/transaction';
import exchangeListReducer from '../hoc/exchange/store/slices/list';
import transactionsRootReducer from '../hoc/transactions/store/slice';
import exchangeTransactionReduces from '../hoc/exchange/store/slices/transaction';
import signaturesReduces from './signature/slice';
import cashCollectionListReducer from '../hoc/cash-collection/store/slices/list';
import restatementTransactionsListReducer from '../hoc/restatement-transactions/store/slice';
import transactionsNotificationCenterReducer from '../hoc/notification-center/store/slices';

export const transactionsApi = api;

export const transactionsReducers = {
  transactionsApi: api.reducer,
  transactions: transactionsRootReducer,
  transactionsDictionaries: dictionariesReduces,
  statuses: statusesReduces,
  signatures: signaturesReduces,
  generalLedger: combineReducers({
    list: generalLedgerListReducer,
    transaction: generalLedgerTransactionReducer,
  }),
  transactionFee: transactionFeeReducer,
  internal: combineReducers({
    list: internalListReducer,
    transaction: internalTransactionReducer,
  }),
  incoming: combineReducers({
    list: incomingListReducer,
    transaction: incomingTransactionReducer,
  }),
  outgoing: combineReducers({
    list: outgoingListReducer,
    transaction: outgoingTransactionReducer,
  }),
  export: combineReducers({
    banks: exportBanksReducer,
    accounts: exportAccountsReducer,
    batches: exportBatchesReducer,
    list: exportTransactionListReducer,
  }),
  import: combineReducers({
    list: importTransactionListReducer,
  }),
  nostro: combineReducers({
    list: nostroListReducer,
    transaction: nostroTransactionReducer,
  }),
  exchange: combineReducers({
    list: exchangeListReducer,
    transaction: exchangeTransactionReduces,
  }),
  cashCollection: combineReducers({
    list: cashCollectionListReducer,
  }),
  restatementTransactions: combineReducers({
    list: restatementTransactionsListReducer,
  }),
  transactionsNotificationCenter: transactionsNotificationCenterReducer,
};
